import TagManager from 'react-gtm-module';

export function initTagManager() {
  TagManager.initialize({
    gtmId: 'GTM-NVLG3S9',
  });
}
